import * as React from "react";
import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseComponent } from "../../../../../../react-core/Html/BaseComponent";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { ActivityStatus } from "../../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ActivityStatus";
import { ProcessType } from "../../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType";
import { ClientDashboardFiltersModel } from "../../../../../../Wrap/Models/Domains/Users/DashboardFilter/ClientDashboardFiltersModel";
import { Alert } from "../../../../../Shared/Components/Alert";
import { TextAndDots } from "../../../../../Shared/Dropdown/TextAndDots";
import { AlertType } from "../../../../../Shared/Entities/Constants/AlertConstants";
import { Table } from "../../../../../Shared/Table/Table";
import { Navigator } from "../../../../../Shared/Wizards/Entities/Navigator";
import { Urls } from "../../../../Urls";
import { subAccountTypeMap } from "../../../Clients/PortfolioDashboard/Components/Performance/Resource/Contents";
import { ClientRecordAction } from "../../../Clients/ClientRecord/Action/ClientRecordAction";
import { DashboardAction } from "../../Action/DashboardAction";
import {
    DateRangeOptionTypeMap,
    FilterActivityStatusMap,
    ProcessTypeMapForNew,
    ProcessTypeOptionsForLegacy,
    ProcessTypeOptionsMapForLegacy,
    ProcessTypeOptionsMapForLegacyActivityTab,
    transferMsg,
} from "../../Resource/Content";
import { switchCancel, switchView, switchResume } from "../../Resource/WorkflowHelper";
import { DashboardFilterStore } from "../../Store/Variable";
import { DeleteLightbox } from "../../../../Common/DeleteLightbox";
import { TransferTracker } from "./TransferTracker";
import { UnmountClosed } from "react-collapse";
import { WorkflowCollectionModel } from "../../../../../../Wrap/Models/Domains/Workflow/WorkflowCollectionModel";
import { Workflow as WorkflowModel } from "../../../../../../Wrap/Models/Domains/Workflow/Workflow";
import TableFilterDropdown from "../../../../../../react-core/Html/Components/TableFilterDropdown";
import { DashboardFilterForm } from "./DashboardFilterForm";
import { HierarchyIdHelper } from "../../../../../Shared/Common/HierarchyIdHelper";
import { HierarchyLevelName } from "../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { LoadingSkeleton } from "../../../../../Shared/LoadingSkeleton/LoadingSkeleton";
import { LoadingSkeletonType } from "../../../../../Shared/LoadingSkeleton/Contents";
import { FullScreenTableModeButton } from "../../../../../../react-core/Html/Components/FullScreenTableModeButton";
import { UserStore } from "../../../../Stroes/Variable";
import { UserClaim } from "../../../../../../Wrap/Constants/Enums/UserClaim";
import { checkPermission } from "../../../../../Shared/Permission/PermissionHelper";
import { PermissionAction } from "../../../../../Shared/Permission/Action/PermissionAction";
import { StaticUrls } from "../../../../Resoures/StaticUrls";
import { CommonHelper } from "../../../../../../react-core/Helpers/CommonHelper";
import AdviserSiteTagManager, {
    eventCategoryForGTM,
} from "../../../../../Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";
import { PortfolioDashboardAction } from "../../../Clients/PortfolioDashboard/Action/PortfolioDashboardAction";
import { InstructionStatus } from "../../../../../../Wrap/Constants/Enums/Domain/InstructionStatus";

interface IWorkflowProps extends React.Props<Workflow> {
    selectedHeadAccounts: string[];
    selectedSubAccounts: string[];
    customerId: number;
    isActivity: boolean;
    notProspect?: boolean;
    selectedCompanyCode?: string;
    selectedAdviserId?: number;
    hasReadWriteAccessForAdviser?: boolean;
}

interface IWorkflowState {
    currentFilter: ClientDashboardFiltersModel;
    usingDefaultFilter: boolean;
    curPage: number;
    data: WorkflowCollectionModel;
    showDeleteLightbox: boolean;
    deleteInstructionId: string;
    deleteAccountId: string;
    deleteProcessType: ProcessType;
    isLoading?: boolean;
    deleteWizardSessionId: string;
}

export class Workflow extends BaseComponent<IWorkflowProps, IWorkflowState> {
    constructor(props: any) {
        super(props);
        this.state = {
            currentFilter: DashboardFilterStore.getFilterItemById(null),
            usingDefaultFilter: true,
            curPage: 1,
            data: null,
            showDeleteLightbox: false,
            deleteInstructionId: null,
            deleteProcessType: null,
            deleteAccountId: null,
            deleteWizardSessionId: null,
        };
        this.subscribeToStore(DashboardFilterStore, () => this.onPressFilter());
    }

    private addEvent = new AdviserSiteTagManager().addEvent;

    componentDidMount() {
        this.defaultFilter();
        if (!this.props.isActivity) {
            this.addEvent({
                environment: {
                    appType: "web",
                    setting: "prod",
                    timestamps: JsonDateParser.toJsonDateNoOffset(new Date()).toString(),
                },
                page: {
                    pageUrl: window.location.pathname.includes("workflow")
                        ? window.location.pathname
                        : window.location.pathname + "/workflow",
                    pageTitle: `${document.title} - dashboard - workflow`,
                },
                user: {
                    loginId: UserStore.getUserInfo()?.ClientId.toString(),
                    internal: "yes",
                },
                event: "pageLoaded",
            });
        }
    }

    componentDidUpdate(prevProps: IWorkflowProps) {
        if (
            JSON.stringify(prevProps.selectedHeadAccounts) != JSON.stringify(this.props.selectedHeadAccounts) ||
            JSON.stringify(prevProps.selectedSubAccounts) != JSON.stringify(this.props.selectedSubAccounts)
        ) {
            this.defaultFilter();
        }
    }

    private defaultFilter = () => {
        const { selectedAdviserId, selectedCompanyCode, isActivity } = this.props;
        const defaultFilter = DashboardFilterStore.getDefaultFilter(isActivity);
        if (selectedAdviserId) {
            defaultFilter.AdviserIds = [selectedAdviserId];
        }
        if (selectedCompanyCode) {
            defaultFilter.CompanyCode = selectedCompanyCode;
        }
        this.setState({ currentFilter: defaultFilter, curPage: 1, usingDefaultFilter: true, isLoading: true });
        this.searchWorkflow(defaultFilter, 1);
    };

    private onPressFilter = () => {
        if (DashboardFilterStore.getActionType() == ActionType.Update) {
            const id = DashboardFilterStore.getPressedId();
            const filter = DashboardFilterStore.getFilterItemById(id);
            this.setState({ currentFilter: filter, curPage: 1, usingDefaultFilter: id == null, isLoading: true });
            this.searchWorkflow(filter, 1);
        }
    };

    private searchWorkflow = (filter: ClientDashboardFiltersModel, curPage) => {
        const { selectedHeadAccounts, selectedSubAccounts, customerId } = this.props;
        const query = DashboardFilterStore.convertDashboardFilterToQuery(
            filter,
            curPage,
            selectedHeadAccounts,
            selectedSubAccounts,
            customerId
        );

        DashboardAction.getWorkflowTable(query, (d) => {
            var result = this.filterWorkflows(d?.PageOfResults ?? []);
            this.setState({
                data:
                {
                    PageOfResults: result,
                    TotalNumberOfResults: d?.TotalNumberOfResults,
                }, isLoading: false
            });
        });
    };

    private filterWorkflows(workflows: Array<WorkflowModel>): Array<WorkflowModel> {
        if (workflows.length == 0) { return [] }
        return workflows.filter(x => this.excludeCondition(x))
    }

    private excludeCondition(workflow: WorkflowModel): boolean {
        return !(workflow.ProcessType==ProcessType.Transfer && workflow.ActivityStatus==ActivityStatus.Cancelled);
    }

    private convertFilterToString(filter: ClientDashboardFiltersModel): string {
        const map = { ...ProcessTypeMapForNew, ...ProcessTypeOptionsMapForLegacy };
        return `${DateRangeOptionTypeMap[filter.DateRangeOption]}, Activity: ${
            map[filter.FilterActivityType]
        }, Status: ${FilterActivityStatusMap[filter.FilterActivityStatus]},  Product: ${
            subAccountTypeMap[filter.FilterProductType]
        }`;
    }

    private actionLinkConfig(row: WorkflowModel) {
        const links = [];
        if (row.WizardSessionId != null && row.WizardSessionId != "0") {
            // old wizard - direct to DLU page
            if (
                (row.ActivityStatus == ActivityStatus.Pending || row.ActivityStatus == ActivityStatus.RejectTransferOnly) &&
                row.HaveReadWriteAccessToAdviser == true &&
                UserStore.getUserInfo()?.IsReadOnly != true
            ) {
                if (row.HaveLandingPageUrlPermission)
                    {links.push({
                        title: "Resume",
                        url: `${row.LandingPageUrl}?wizardsessionid=${row.WizardSessionId}&claccountid=${row.ClAccountId}`,
                    });}
            } else if (
                row.ProcessType == ProcessType.RegularReviewRebalance &&
                checkPermission(UserClaim.AdviserPortalDluReviewCompleteCanView)
            ) {
                links.push({
                    title: "View",
                    url: StaticUrls.reviewRegularReviewRebalanceCompleteUrl(row.WizardSessionId, row.ClAccountId),
                });
            } else if (
                [ActivityStatus.Complete, ActivityStatus.AwaitingAuthorisation, ActivityStatus.Submitted].includes(
                    row.ActivityStatus
                ) &&
                row.ProcessType != ProcessType.PpToIsaFeedTool &&
                checkPermission(UserClaim.AdviserPortalDluCompleteWizardCanView)
            ) {
                links.push({
                    title: "View",
                    url: StaticUrls.completedWizardUrl(row.WizardSessionId, row.ClAccountId),
                });
            }
        } else {
            if (
                (row.ActivityStatus == ActivityStatus.Pending || row.ActivityStatus == ActivityStatus.RejectTransferOnly) &&
                row.HaveReadWriteAccessToAdviser == true &&
                UserStore.getUserInfo()?.IsReadOnly != true
            ) {
                // incomplete instruction : Resume
                const urlWithPermission = switchResume(row.ProcessType, row);
                if (!CommonHelper.isNullOrEmpty(urlWithPermission))
                    {links.push({ title: "Resume", url: urlWithPermission });}
            } else if (
                row.ActivityStatus == ActivityStatus.Complete ||
                row.ActivityStatus == ActivityStatus.Submitted
            ) {
                // completed or submitted instruction: View
                const urlWithPermission = switchView(row.ProcessType, row);
                if (!CommonHelper.isNullOrEmpty(urlWithPermission))
                    {links.push({ title: "View", url: switchView(row.ProcessType, row) });}
                if (row.ProcessType == ProcessType.Quote) {
                    links.push({
                        title: "New Business",
                        url: "#",
                        clickFunction: () => {
                            ClientRecordAction.copyQuoteByid(parseInt(row.ReferenceNumber), row.CustomerId);
                            return false;
                        },
                    });
                }
            } else if (
                (row.ActivityStatus == ActivityStatus.PendingTransferOnly ||
                    row.ActivityStatus == ActivityStatus.ReviewedTransferOnly) &&
                checkPermission(UserClaim.AdviserPortalDluReregistrationTransfersCanView)
            ) {
                links.push({
                    title: "View",
                    url: StaticUrls.reregistrationTransfersUrl(row.ClAccountId),
                });
            }
            if (row.ActivityStatus == ActivityStatus.AwaitingAuthorisation) {
                const urlWithPermission = switchView(row.ProcessType, row);
                if (!CommonHelper.isNullOrEmpty(urlWithPermission))
                    {links.push({ title: "View", url: urlWithPermission });}
            }
        }
        return links;
    }

    private form = null;
    private dropdown = null;

    private onDeleteInstruction() {
        const {
            deleteInstructionId,
            deleteProcessType,
            currentFilter,
            curPage,
            deleteAccountId,
            deleteWizardSessionId,
        } = this.state;
        if (deleteProcessType == null || !deleteInstructionId) {return;}
        this.setState({ isLoading: true });

        switchCancel(
            deleteProcessType,
            deleteInstructionId,
            () => {
                this.searchWorkflow(currentFilter, curPage);
                if (deleteProcessType == ProcessType.NewBusiness && this.props.isActivity) {
                    PortfolioDashboardAction.getAllAccountsByCustomerId(this.props.customerId);
                }
            },
            deleteWizardSessionId,
            deleteAccountId
        );
    }

    private rendertable(data, currentFilter, curPage) {
        return (
            <>
                <Table
                    data={data.PageOfResults}
                    isScrollable={false}
                    showEmptyMsg
                    needPagination={{
                        totalNumOfResult: data.TotalNumberOfResults,
                        onPaginationChange: (pageIndex, pageSize) => {
                            this.setState({ curPage: pageIndex, isLoading: true });
                            this.searchWorkflow(currentFilter, pageIndex);
                        },
                        currentPage: curPage,
                    }}
                    col={[
                        {
                            title: "Date started",
                            key: "CreateDate",
                            thCssWrapper: "cell-15",
                            render: (data, row, index) => {
                                return JsonDateParser.getFormatDate(data, "dd/MM/yyyy");
                            },
                            toogleOptions: (row: WorkflowModel, index) => {
                                return {
                                    toogleable: row.ProcessType == ProcessType.Transfer,
                                    expandContent: (
                                        <UnmountClosed isOpened={true}>
                                            <div className="te-subwrap pt-20 pb-20 pr-40 pl-40">
                                                <div>
                                                    <span className="text-bold">Transfering from: </span> {row.Provider}
                                                </div>
                                                <div>
                                                    <span className="text-bold">Last updated: </span>{" "}
                                                    {JsonDateParser.getFormatDateString(
                                                        JsonDateParser.toDate(row.LastUpdateDate),
                                                        "dd MM yyyy",
                                                        true,
                                                        true
                                                    )}
                                                </div>
                                                {[
                                                    ActivityStatus.Complete,
                                                    ActivityStatus.PendingTransferOnly,
                                                    ActivityStatus.ReviewedTransferOnly,
                                                ].includes(row.ActivityStatus) && (
                                                    <TransferTracker
                                                        cssWrapper={`${
                                                            row.ActivityStatus == ActivityStatus.ReviewedTransferOnly
                                                                ? "pending"
                                                                : row.ActivityStatus == ActivityStatus.Complete
                                                                ? "complete"
                                                                : "start"
                                                        } mb-20`}
                                                        secondStep={
                                                            row.ActivityStatus != ActivityStatus.PendingTransferOnly
                                                        }
                                                        complete={row.ActivityStatus == ActivityStatus.Complete}
                                                    />
                                                )}
                                                <p className="warning-message mt-16 mb-10">
                                                    {transferMsg[row.ActivityStatus]}
                                                </p>
                                            </div>
                                        </UnmountClosed>
                                    ),
                                };
                            },
                        },
                        {
                            title: "Account number",
                            key: "ClAccountId",
                        },
                        this.props.isActivity
                            ? {
                                  title: "Account name",
                                  key: "AccountName",
                              }
                            : {
                                  title: "Name",
                                  key: "CustomerName",
                                  render: (data, row: WorkflowModel, index) => {
                                      if (row.ProcessType == ProcessType.Transfer) {
                                          return row.AccountName;
                                      }
                                      return (
                                          <button
                                              className="hyperlink text-left"
                                              onClick={() => {
                                                  if (checkPermission(UserClaim.AdviserPortalClientSummaryCanView))
                                                      {Navigator.navigateTo(
                                                          Urls.get().main.PortfolioDashboard({
                                                              hierarchyId: HierarchyIdHelper.toHierarchyIdString(
                                                                  HierarchyLevelName.Customer,
                                                                  row?.CustomerId
                                                              ),
                                                          }).summary
                                                      );}
                                              }}
                                          >
                                              {row.CustomerName}
                                          </button>
                                      );
                                  },
                              },

                        {
                            title: "Activity type",
                            key: "ProcessType",
                            render: (data) => {
                                const map = { ...ProcessTypeMapForNew, ...ProcessTypeOptionsMapForLegacy };
                                return map[data];
                            },
                        },
                        {
                            title: "Reference number",
                            key: "ReferenceNumber",
                            render: (data, row: WorkflowModel, index) => {
                                if (ProcessTypeOptionsForLegacy.includes(row?.ProcessType) && Number(row?.WizardSessionId) > 0 ) {
                                    return row?.WizardSessionId;
                                }
                                if (row.ProcessType != ProcessType.Transfer) {return data;}
                                return `${subAccountTypeMap[row.ProductType]} ${row.ClAccountId}`;
                            },
                        },
                        {
                            title: "Adviser",
                            key: "AdviserName",
                        },
                        {
                            title: "Status",
                            key: "ActivityStatus",
                            render: (data) => {
                                return FilterActivityStatusMap[data];
                            },
                        },
                        {
                            title: "Created by",
                            key: "CreatedBy",
                        },
                        {
                            title: "Last update",
                            key: "LastUpdateDate",
                            render: (data, row, index) => {
                                return JsonDateParser.getFormatDate(data, "dd/MM/yyyy");
                            },
                        },
                        {
                            title: "Action",
                            key: "",
                            render: (data, row: WorkflowModel) => {
                                const links = this.actionLinkConfig(row);
                                if (links.filter((ele) => ele != null).length == 0) {return null;}
                                return <TextAndDots buttonTitle="Quick actions menu" textLinks={links} />;
                            },
                        },
                        {
                            title: "Delete",
                            key: "",
                            render: (data, row: WorkflowModel) => {
                                if (
                                    !(row.ActivityStatus == ActivityStatus.RejectTransferOnly ||
                                    row.ActivityStatus == ActivityStatus.Pending ) ||
                                    (row.WizardSessionId != null &&
                                        row.WizardSessionId != "0" &&
                                        row.HaveAccountRoleInstructionsNbecWizardSessionsMapping) ||
                                    row.HaveReadWriteAccessToAdviser == false ||
                                    UserStore.getUserInfo()?.IsReadOnly == true
                                )
                                    {return null;}

                                return (
                                    <button
                                        className="remove-button label-sr-only"
                                        title="Delete"
                                        onClick={() => {
                                            if (this.props.isActivity) {
                                                this.addEvent({
                                                    event: "activitytab_interaction",
                                                    eventParameters: {
                                                        eventAction: "interactions",
                                                        eventCategory: eventCategoryForGTM.activityTab,
                                                        eventLabel: "delete",
                                                    },
                                                });
                                            }
                                            this.setState({
                                                showDeleteLightbox: true,
                                                deleteInstructionId: row.ReferenceNumber,
                                                deleteProcessType: row.ProcessType,
                                                deleteAccountId: row.ClAccountId,
                                                deleteWizardSessionId: row.WizardSessionId,
                                            });
                                        }}
                                    >
                                        <span className="icon" aria-hidden="true"></span>
                                    </button>
                                );
                            },
                        },
                    ]}
                />
                {this.state.showDeleteLightbox && (
                    <DeleteLightbox
                        onClose={() => this.setState({ showDeleteLightbox: false })}
                        onDelete={() => this.onDeleteInstruction()}
                        content={<p>Are you sure you want to delete this activity?</p>}
                    />
                )}
            </>
        );
    }

    public render(): JSX.Element {
        const { data, curPage, currentFilter, isLoading, usingDefaultFilter } = this.state;
        if (!data || isLoading) {return <LoadingSkeleton type={LoadingSkeletonType.Table} />;}
        return (
            <>
                <Alert
                    alertType={AlertType.Notification}
                    message={this.convertFilterToString(this.state.currentFilter)}
                    onAlertClose={() => {
                        DashboardAction.setPressedId(null);
                        this.defaultFilter();
                    }}
                    hideCloseButton={usingDefaultFilter}
                />

                <div className="row row-right mb-8">
                    <div className="col-auto">
                        <TableFilterDropdown
                            cssWrapper="table-default-filter"
                            onOpen={(ref) => (this.dropdown = ref)}
                            title="Workflow table filter"
                            event={
                                this.props.isActivity
                                    ? {
                                          event: "activitytab_interaction",
                                          eventParameters: {
                                              eventAction: "interactions",
                                              eventCategory: eventCategoryForGTM.activityTab,
                                              eventLabel: "filter cilck",
                                          },
                                      }
                                    : null
                            }
                        >
                            <>
                                <DashboardFilterForm
                                    data={currentFilter}
                                    onRef={(v) => (this.form = v)}
                                    isLightbox={false}
                                    isActivity={this.props.isActivity}
                                />
                                <button className="btn secondary mr-10" onClick={() => this.dropdown(true)}>
                                    Cancel
                                </button>
                                <button
                                    className="btn primary"
                                    onClick={() => {
                                        const data = this.form.getData();
                                        if (this.props.isActivity) {
                                            this.addEvent({
                                                event: "activitytab_tablefilter",
                                                filter: {
                                                    date: DateRangeOptionTypeMap[data?.DateRangeOption].toLowerCase(),
                                                    actvityType: {
                                                        ...ProcessTypeMapForNew,
                                                        ...ProcessTypeOptionsMapForLegacyActivityTab,
                                                    }[data?.FilterActivityType].toLowerCase(),
                                                    activityStatus: FilterActivityStatusMap[
                                                        data?.FilterActivityStatus
                                                    ].toLowerCase(),
                                                    product: subAccountTypeMap[data?.FilterProductType].toLowerCase(),
                                                },
                                            });
                                        }
                                        if (this.form.isValid()) {
                                            this.setState({
                                                currentFilter: data,
                                                curPage: 1,
                                                isLoading: true,
                                                usingDefaultFilter: false,
                                            });
                                            this.searchWorkflow(data, 1);
                                            this.dropdown(true);
                                        }
                                    }}
                                >
                                    Apply
                                </button>
                            </>
                        </TableFilterDropdown>
                    </div>
                    <div className="col-auto col-middle">
                        <FullScreenTableModeButton
                            onClick={
                                this.props.isActivity
                                    ? () => {
                                          this.addEvent({
                                              event: "activitytab_interaction",
                                              eventParameters: {
                                                  eventAction: "interactions",
                                                  eventCategory: eventCategoryForGTM.activityTab,
                                                  eventLabel: "expand",
                                              },
                                          });
                                      }
                                    : null
                            }
                        >
                            {this.rendertable(data, currentFilter, curPage)}
                        </FullScreenTableModeButton>
                    </div>
                </div>
                {this.rendertable(data, currentFilter, curPage)}
            </>
        );
    }
}
